/**
 * AuditFooter — mono-register footer carrying engine version, consent record,
 * blueprint id, and page indicator. The instrument-grade audit register that
 * sits at the bottom of every printed Blueprint page per
 * /design/mockups/Phase1_Brand_Demonstrator_v10.html.
 *
 * Per `/policy/brand-discipline.md` §9, every Blueprint footer also carries
 * the disclaimer line; this component renders it above the audit register
 * by default (toggleable for the rare case where it's surfaced separately).
 *
 * Per V1 staging follow-up #1: `jargon_scan_passed` is server-side CI
 * scaffolding (lives on the blueprints table for fairness-audit consumption)
 * and is no longer rendered to the user-facing footer. The prop is still
 * accepted for backward compatibility with existing callers but is ignored.
 */

const DISCLAIMER =
  "For decision and conversation prep, not legal, medical, or clinical advice.";

export default function AuditFooter({
  engineVersion,
  // jargonScanPassed intentionally unused — see component header.
  // eslint-disable-next-line no-unused-vars
  jargonScanPassed,
  consentRecord,
  blueprintId,
  pageIndicator = "page 1 of 1",
  showDisclaimer = true,
}) {
  return (
    <footer
      style={{
        marginTop: 36,
        paddingTop: 18,
        borderTop: "1px solid var(--ppr-color-border-default)",
      }}
      data-component="AuditFooter"
    >
      {showDisclaimer ? (
        <div
          style={{
            fontFamily: "var(--ppr-typography-font-family-body)",
            fontSize: "12px",
            fontStyle: "italic",
            color: "var(--ppr-color-text-muted)",
            marginBottom: 10,
          }}
        >
          {DISCLAIMER}
        </div>
      ) : null}
      <div
        style={{
          fontFamily: "var(--ppr-typography-font-family-mono)",
          fontSize: "var(--ppr-typography-font-size-xs)",
          color: "var(--ppr-color-text-muted)",
          letterSpacing: "0.02em",
          display: "flex",
          flexWrap: "wrap",
          gap: 14,
        }}
      >
        {engineVersion ? <span>engine: {engineVersion}</span> : null}
        {consentRecord ? <span>consent_record: {consentRecord}</span> : null}
        {blueprintId ? <span>blueprint_id: {blueprintId}</span> : null}
        {pageIndicator ? (
          <span style={{ marginLeft: "auto" }}>{pageIndicator}</span>
        ) : null}
      </div>
    </footer>
  );
}
